/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OcppConfig } from '../../models/ocpp-config';

export interface GetOcppConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected ocpp configuration
 */
  ocppUid: string;
}

export function getOcppConfigurations(http: HttpClient, rootUrl: string, params: GetOcppConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<OcppConfig>> {
  const rb = new RequestBuilder(rootUrl, getOcppConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('ocppUid', params.ocppUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OcppConfig>;
    })
  );
}

getOcppConfigurations.PATH = '/stations/{uid}/ocpp/{ocppUid}';
